export const routerFor = (list, key) => {
    const arr = [];
    let itemIndex = 0;
    list.map((item) => {
        let isTrue = false;
        if (item.privilegeVoList) {
            item.privilegeVoList.map((vo) => {
                if (vo.privilegeCode == "100501" && vo.checked) {
                    isTrue = true;
                }
            });
        }
        if (!item.privilegeVoList) {
            isTrue = true;
        }
        if (key) {
            item.menuIndex = key + "-" + itemIndex;
        }
        else {
            item.menuIndex = itemIndex + "";
        }
        if (item.children) {
            item.children = routerFor(item.children, item.menuIndex);
        }
        if (isTrue) {
            itemIndex = itemIndex + 1;
            arr.push(item);
        }
    });
    return arr;
};
export const routerForUrl = (list) => {
    let itemData = null;
    let isTrue = false;
    list.map((item) => {
        if (item.privilegeVoList) {
            item.privilegeVoList.map((vo) => {
                if (vo.privilegeCode == "100501" && vo.checked) {
                    if ((!itemData && !item.children) ||
                        (!itemData && item.children.length == 0)) {
                        itemData = item;
                    }
                    else {
                        isTrue = true;
                    }
                }
            });
        }
        if (!itemData && isTrue) {
            itemData = routerForUrl(item.children);
        }
    });
    return itemData;
};
